import React from 'react';
import Immutable from 'immutable';
import Range from '../containers/range';
import { createRuntimeRange, EMPTY_RUNTIME_RANGE } from '../../data/runtimeutils';
import RuntimeInput from './runtimeinput';

export default class RuntimeRangeInput extends React.PureComponent {
	onChange(value) {
		if (this.props.onChange) {
			this.props.onChange(value);
		}
	}

	render() {
		const value = this.props.value || EMPTY_RUNTIME_RANGE;
		return (
			<Range width={this.props.width} minWidth={this.props.minWidth} className="ps-numberRange">
				<RuntimeInput
					value={value.get('from')}
					groupless={this.props.groupless}
					size={this.props.inputSize}
					onChange={from => {
						this.onChange(createRuntimeRange(from, value.get('to')));
					}}
					placeholder={this.props.placeholderFrom}
				/>
				<RuntimeInput
					value={value.get('to')}
					groupless={this.props.groupless}
					size={this.props.inputSize}
					onChange={to => {
						this.onChange(createRuntimeRange(value.get('from'), to));
					}}
					placeholder={this.props.placeholderTo}
				/>
			</Range>
		)
	}
}
